<template>
    <div>
        <div class="mt-1 pa-2" style="max-height: 400px"> 
            <h3 class="elevation-24 primary darken-2 pa-2 white--text font-weight-bold text-xs-left">
                ({{requestedTransactions.length}}) Transactions
            </h3>
            <v-divider></v-divider>
            
            <template v-for="item in requestedTransactions">
                <!-- Pending Orders (Blue border) -->
                <v-hover v-if="item.status_code === 'Pending'" :key="item.id">
                    <v-card
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 8 : 2}`"
                        :to="'/market_place/shopping_bag/items/transactions/'+item.id"
                        color="white"
                        class="transaction-card mb-3"
                        style="border-left: 5px solid #2196F3!important; transition: all 0.3s ease;"
                    >
                        <v-card-text class="pt-3 pb-2">
                            <v-layout row wrap align-center class="mb-2">
                                <v-flex xs8>
                                    <h3 class="blue--text text--darken-2 mb-1">
                                        <v-icon color="blue darken-2" class="mr-1">shopping_cart</v-icon>
                                        <span class="font-weight-bold">{{item.order_id}}</span>
                                    </h3>
                                </v-flex>
                                <v-flex xs4 text-xs-right>
                                    <v-chip small color="blue" text-color="white" class="ma-0">
                                        <v-icon small left>schedule</v-icon>
                                        Pending
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <div v-if="getProductNames(item).length > 0" class="mb-2">
                                <v-chip small color="blue lighten-5" text-color="blue darken-3" class="ma-1" v-for="(productName, index) in getProductNames(item)" :key="index">
                                    <v-icon small left>shopping_basket</v-icon>
                                    {{productName}}
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <v-layout row wrap>
                                <v-flex xs6>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Cost</span>
                                        <div class="font-weight-bold">{{item.total_cost}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Paid</span>
                                        <div class="font-weight-bold">{{item.total_paid}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 class="mt-2">
                                    <span class="caption grey--text">
                                        <v-icon small>event</v-icon>
                                        {{item.get_date_str}}
                                    </span>
                                </v-flex>
                            </v-layout>

                            <v-divider class="my-3"></v-divider>

                            <!-- Action Buttons for Pending -->
                            <v-layout row wrap justify-space-around>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="success"
                                        @click.prevent="openWhatsApp(item)"
                                        class="stylish-btn whatsapp-btn"
                                        depressed
                                    >
                                        <v-icon small>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="blue darken-2"
                                        @click.prevent="openPettyCashChat(item)"
                                        class="stylish-btn chat-btn"
                                        depressed
                                    >
                                        <v-icon small>chat</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="orange lighten-1"
                                        @click.prevent="showPendingPaymentMessage()"
                                        class="stylish-btn map-btn"
                                        depressed
                                    >
                                        <v-icon small>location_on</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-hover>

                <!-- Paid Orders - PettyCash Account (Green with wallet icon) -->
                <v-hover v-else-if="item.status_code === 'Paid' && item.payment_means === 'My Account'" :key="item.id">
                    <v-card
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 3}`"
                        color="white"
                        :to="'/market_place/shopping_bag/items/transactions/'+item.id"
                        class="transaction-card mb-3 paid-account-card"
                        style="border-left: 5px solid #00897B!important; transition: all 0.3s ease;"
                    >
                        <v-card-text class="pt-3 pb-2">
                            <v-layout row wrap align-center class="mb-2">
                                <v-flex xs8>
                                    <h3 class="teal--text text--darken-2 mb-1">
                                        <v-icon color="teal darken-2" class="mr-1">account_balance_wallet</v-icon>
                                        <span class="font-weight-bold">{{item.order_id}}</span>
                                    </h3>
                                </v-flex>
                                <v-flex xs4 text-xs-right>
                                    <v-chip small color="teal darken-2" text-color="white" class="ma-0">
                                        <v-icon small left>check_circle</v-icon>
                                        Paid
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <v-chip
                                small
                                color="teal lighten-5"
                                text-color="teal darken-3"
                                class="mb-2"
                            >
                                <v-icon small left color="teal darken-2">credit_card</v-icon>
                                PettyCash Account
                            </v-chip>

                            <div v-if="getProductNames(item).length > 0" class="mb-2">
                                <v-chip small color="teal lighten-5" text-color="teal darken-3" class="ma-1" v-for="(productName, index) in getProductNames(item)" :key="index">
                                    <v-icon small left>shopping_basket</v-icon>
                                    {{productName}}
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <v-layout row wrap>
                                <v-flex xs6>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Cost</span>
                                        <div class="font-weight-bold">{{item.total_cost}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Paid Amount</span>
                                        <div class="teal--text text--darken-2 font-weight-bold">{{item.total_paid}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 class="mt-2" v-if="item.shipping_location">
                                    <div class="delivery-info">
                                        <v-icon small color="teal darken-2">local_shipping</v-icon>
                                        <span class="caption ml-1">
                                            <strong>Delivery:</strong> {{item.shipping_location}}, {{item.shipping_town}}
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-divider class="my-3"></v-divider>

                            <!-- Stylized Action Buttons -->
                            <v-layout row wrap justify-space-around>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="success"
                                        @click.prevent="openWhatsApp(item)"
                                        class="stylish-btn whatsapp-btn"
                                        depressed
                                    >
                                        <v-icon small>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="teal darken-2"
                                        @click.prevent="openPettyCashChat(item)"
                                        class="stylish-btn chat-btn"
                                        depressed
                                    >
                                        <v-icon small>chat</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="primary"
                                        @click.prevent="showLocationInfo(item)"
                                        class="stylish-btn map-btn"
                                        depressed
                                        v-if="item.shipping_location"
                                    >
                                        <v-icon small>location_on</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <div class="mt-2 text-xs-center">
                                <span class="caption grey--text">
                                    <v-icon x-small>event</v-icon>
                                    {{item.get_date_str}}
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>

                <!-- Paid Orders - Mobile Money (Orange with phone icon) -->
                <v-hover v-else-if="item.status_code === 'Paid' && item.payment_means !== 'My Account'" :key="item.id">
                    <v-card
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 3}`"
                        color="white"
                        :to="'/market_place/shopping_bag/items/transactions/'+item.id"
                        class="transaction-card mb-3 paid-mobile-card"
                        style="border-left: 5px solid #FF9800!important; transition: all 0.3s ease;"
                    >
                        <v-card-text class="pt-3 pb-2">
                            <v-layout row wrap align-center class="mb-2">
                                <v-flex xs8>
                                    <h3 class="orange--text text--darken-2 mb-1">
                                        <v-icon color="orange darken-2" class="mr-1">smartphone</v-icon>
                                        <span class="font-weight-bold">{{item.order_id}}</span>
                                    </h3>
                                </v-flex>
                                <v-flex xs4 text-xs-right>
                                    <v-chip small color="orange darken-2" text-color="white" class="ma-0">
                                        <v-icon small left>check_circle</v-icon>
                                        Paid
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <v-chip
                                small
                                color="orange lighten-5"
                                text-color="orange darken-3"
                                class="mb-2"
                            >
                                <v-icon small left color="orange darken-2">phone_iphone</v-icon>
                                {{item.payment_means || 'Mobile Money'}}
                            </v-chip>

                            <div v-if="getProductNames(item).length > 0" class="mb-2">
                                <v-chip small color="orange lighten-5" text-color="orange darken-3" class="ma-1" v-for="(productName, index) in getProductNames(item)" :key="index">
                                    <v-icon small left>shopping_basket</v-icon>
                                    {{productName}}
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <v-layout row wrap>
                                <v-flex xs6>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Cost</span>
                                        <div class="font-weight-bold">{{item.total_cost}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Paid Amount</span>
                                        <div class="orange--text text--darken-2 font-weight-bold">{{item.total_paid}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 class="mt-2" v-if="item.shipping_location">
                                    <div class="delivery-info">
                                        <v-icon small color="orange darken-2">local_shipping</v-icon>
                                        <span class="caption ml-1">
                                            <strong>Delivery:</strong> {{item.shipping_location}}, {{item.shipping_town}}
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-divider class="my-3"></v-divider>

                            <!-- Stylized Action Buttons -->
                            <v-layout row wrap justify-space-around>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="success"
                                        @click.prevent="openWhatsApp(item)"
                                        class="stylish-btn whatsapp-btn"
                                        depressed
                                    >
                                        <v-icon small>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="orange darken-2"
                                        @click.prevent="openPettyCashChat(item)"
                                        class="stylish-btn chat-btn"
                                        depressed
                                    >
                                        <v-icon small>chat</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="primary"
                                        @click.prevent="showLocationInfo(item)"
                                        class="stylish-btn map-btn"
                                        depressed
                                        v-if="item.shipping_location"
                                    >
                                        <v-icon small>location_on</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <div class="mt-2 text-xs-center">
                                <span class="caption grey--text">
                                    <v-icon x-small>event</v-icon>
                                    {{item.get_date_str}}
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>

                <!-- Payment Validated/Delivered Orders (Green) -->
                <v-hover v-else-if="item.status_code === 'Payment Validated' || item.status_code === 'Delivered'" :key="item.id">
                    <v-card
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 3}`"
                        color="white"
                        :to="'/market_place/shopping_bag/items/transactions/'+item.id"
                        class="transaction-card mb-3 paid-account-card"
                        style="border-left: 5px solid #4CAF50!important; transition: all 0.3s ease;"
                    >
                        <v-card-text class="pt-3 pb-2">
                            <v-layout row wrap align-center class="mb-2">
                                <v-flex xs8>
                                    <h3 class="green--text text--darken-2 mb-1">
                                        <v-icon color="green darken-2" class="mr-1">check_circle</v-icon>
                                        <span class="font-weight-bold">{{item.order_id}}</span>
                                    </h3>
                                </v-flex>
                                <v-flex xs4 text-xs-right>
                                    <v-chip small color="success" text-color="white" class="ma-0">
                                        {{item.status_code}}
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <div v-if="getProductNames(item).length > 0" class="mb-2">
                                <v-chip small color="green lighten-5" text-color="green darken-3" class="ma-1" v-for="(productName, index) in getProductNames(item)" :key="index">
                                    <v-icon small left>shopping_basket</v-icon>
                                    {{productName}}
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <v-layout row wrap>
                                <v-flex xs6>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Cost</span>
                                        <div class="font-weight-bold">{{item.total_cost}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Paid</span>
                                        <div class="green--text text--darken-2 font-weight-bold">{{item.total_paid}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 class="mt-2" v-if="item.shipping_location">
                                    <div class="delivery-info">
                                        <v-icon small color="green darken-2">local_shipping</v-icon>
                                        <span class="caption ml-1">
                                            <strong>Delivery:</strong> {{item.shipping_location}}, {{item.shipping_town}}
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-divider class="my-3"></v-divider>

                            <!-- Action Buttons -->
                            <v-layout row wrap justify-space-around>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small block color="success"
                                        @click.prevent="openWhatsApp(item)"
                                        class="stylish-btn whatsapp-btn"
                                        depressed
                                    >
                                        <v-icon small>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small block color="green darken-2"
                                        @click.prevent="openPettyCashChat(item)"
                                        class="stylish-btn chat-btn"
                                        depressed
                                    >
                                        <v-icon small>chat</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small
                                        block
                                        color="primary"
                                        @click.prevent="showLocationInfo(item)"
                                        class="stylish-btn map-btn"
                                        depressed
                                    >
                                        <v-icon small>location_on</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <div class="mt-2 text-xs-center">
                                <span class="caption grey--text">
                                    <v-icon x-small>event</v-icon>
                                    {{item.get_date_str}}
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>

                <!-- Interrupted Orders (Red) -->
                <v-hover v-else-if="item.status_code === 'Interrupted'" :key="item.id">
                    <v-card
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 8 : 2}`"
                        color="white"
                        :to="'/market_place/shopping_bag/items/transactions/'+item.id"
                        class="transaction-card mb-3"
                        style="border-left: 5px solid #F44336!important; transition: all 0.3s ease;"
                    >
                        <v-card-text class="pt-3 pb-2">
                            <v-layout row wrap align-center class="mb-2">
                                <v-flex xs8>
                                    <h3 class="red--text text--darken-2 mb-1">
                                        <v-icon color="red darken-2" class="mr-1">error</v-icon>
                                        <span class="font-weight-bold">{{item.order_id}}</span>
                                    </h3>
                                </v-flex>
                                <v-flex xs4 text-xs-right>
                                    <v-chip small color="error" text-color="white" class="ma-0">
                                        Interrupted
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <div v-if="getProductNames(item).length > 0" class="mb-2">
                                <v-chip small color="red lighten-5" text-color="red darken-3" class="ma-1" v-for="(productName, index) in getProductNames(item)" :key="index">
                                    <v-icon small left>shopping_basket</v-icon>
                                    {{productName}}
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <v-layout row wrap>
                                <v-flex xs6>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Cost</span>
                                        <div class="font-weight-bold">{{item.total_cost}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 text-xs-right>
                                    <div class="info-item">
                                        <span class="grey--text text--darken-1 caption">Total Paid</span>
                                        <div class="font-weight-bold">{{item.total_paid}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 class="mt-2">
                                    <span class="caption grey--text">
                                        <v-icon small>event</v-icon>
                                        {{item.get_date_str}}
                                    </span>
                                </v-flex>
                            </v-layout>

                            <v-divider class="my-3"></v-divider>

                            <!-- Action Buttons -->
                            <v-layout row wrap justify-space-around>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small block color="success"
                                        @click.prevent="openWhatsApp(item)"
                                        class="stylish-btn whatsapp-btn"
                                        depressed
                                    >
                                        <v-icon small>fab fa-whatsapp</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small block color="red darken-2"
                                        @click.prevent="openPettyCashChat(item)"
                                        class="stylish-btn chat-btn"
                                        depressed
                                    >
                                        <v-icon small>chat</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4 class="pa-1">
                                    <v-btn
                                        small block
                                        color="grey lighten-1"
                                        class="stylish-btn map-btn-disabled"
                                        disabled
                                        depressed
                                    >
                                        <v-icon small>location_off</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <div class="mt-2 text-xs-center">
                                <span class="caption red--text text--lighten-1">
                                    <v-icon x-small color="red lighten-1">warning</v-icon>
                                    Order interrupted - Contact support
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </template>
        </div>

        <!-- Location Information Dialog -->
        <v-dialog v-model="locationDialog" max-width="600px">
            <v-card>
                <v-card-title class="teal darken-2 white--text pa-3">
                    <v-icon left color="white">location_on</v-icon>
                    <span class="headline">Delivery Location</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeLocationDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-4">
                    <div v-if="selectedOrder" class="location-info">
                        <v-layout row wrap class="mb-4">
                            <v-flex xs12>
                                <div class="info-box pa-3 mb-3">
                                    <v-icon color="teal darken-2" class="mr-2">shopping_cart</v-icon>
                                    <strong>Order:</strong> {{selectedOrder.order_id}}
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="info-box pa-3">
                                    <v-icon color="teal darken-2" class="mr-2">location_on</v-icon>
                                    <strong>Delivery Address:</strong> {{selectedOrder.shipping_location}}, {{selectedOrder.shipping_town}}
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-divider class="my-4"></v-divider>

                        <div class="delivery-instructions">
                            <h4 class="mb-3 teal--text text--darken-2">
                                <v-icon left>local_shipping</v-icon>
                                Delivery Information
                            </h4>
                            <p class="mb-3">
                                Your order will be delivered to the specified address. Please ensure someone is available to receive the delivery.
                            </p>
                            <p class="mb-0">
                                For any questions about your delivery location, contact our support team via WhatsApp or Chat.
                            </p>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn color="grey" flat @click="closeLocationDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            requestedTransactions: [],
            locationDialog: false,
            selectedOrder: null
        }
    },

    mounted(){
        document.title = "PettyCash Market Place | Transactions"
        this.getTransactions()
        this.$store.commit('setCloseURL', "/market_place/shopping_bag/items/my_items")
    },

    methods: {
        async fetchProductDetails(transaction) {
            if (!transaction.id) return

            try {
                const response = await axios.get(`/api/v1/market_place/get/user/requested/bill/items/${transaction.id}/`)

                console.log(`📦 Items for order ${transaction.order_id}:`, response.data)

                if (response.data && Array.isArray(response.data)) {
                    transaction.productDetails = response.data
                } else {
                    transaction.productDetails = []
                }

                this.$forceUpdate()
            } catch (error) {
                console.error(`Error fetching items for order ${transaction.id}:`, error)
                transaction.productDetails = []
            }
        },

        getProductNames(transaction) {
            if (!transaction.productDetails || !Array.isArray(transaction.productDetails)) {
                return []
            }

            return transaction.productDetails.map(item => {
                const productName = item.product || item.name
                if (productName) {
                    return item.quantity > 1 ? `${productName} (x${item.quantity})` : productName
                }
                return null
            }).filter(name => name !== null)
        },

        showPendingPaymentMessage() {
            this.$store.commit('setSnackBarMessage', 'Please complete your payment to view delivery location. Contact support via WhatsApp or Chat for assistance.')
            this.$store.commit('setSnackBarColor', 'orange darken-2')
            this.$store.commit('activateSnackBar', true)
        },

        showLocationInfo(order) {
            this.selectedOrder = order
            this.locationDialog = true
        },

        closeLocationDialog() {
            this.locationDialog = false
            this.selectedOrder = null
        },

        async getTransactions(){
            this.$store.commit('setIsLoading', true)

            await axios
                .get('/api/v1/market_place/get/user/requested/bills')
                .then(response => {
                    this.requestedTransactions = response.data
                    console.log('📦 Transactions:', response.data)

                    this.requestedTransactions.forEach(transaction => {
                        this.fetchProductDetails(transaction)
                    })
                })
                .catch(error => {
                    if (error.response){
                        this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }
                })
            this.$store.commit('setIsLoading', false)
        },

        openWhatsApp(order) {
            const phoneNumber = '237656223451'
            const message = encodeURIComponent(
                `Hello PettyCash,\n\nOrder: ${order.order_id}\nTotal: ${order.total_cost} FCFA\n\nThank you!`
            )
            window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
        },

        openPettyCashChat(order) {
            this.$root.$emit('open-chatbot', {
                orderId: order.order_id,
                autoMessage: `Hello, I need assistance with order ${order.order_id}. Total: ${order.total_cost} FCFA.`
            })
        }
    }
}
</script>

<style scoped>
.transaction-card {
    border-radius: 12px !important;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
}

.transaction-card:hover {
    transform: translateY(-3px);
}

.paid-account-card {
    background: linear-gradient(to right, #ffffff 0%, #f1f8f7 100%);
}

.paid-mobile-card {
    background: linear-gradient(to right, #ffffff 0%, #fff8f1 100%);
}

.info-item {
    line-height: 1.4;
}

.delivery-info {
    background: #f5f5f5;
    padding: 8px;
    border-radius: 6px;
    display: flex;
    align-items: center;
}

.info-box {
    background: white;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
}

.stylish-btn {
    border-radius: 50% !important;
    min-width: 48px !important;
    width: 48px !important;
    height: 48px !important;
    padding: 0 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.stylish-btn:hover {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 6px 20px rgba(0,0,0,0.25) !important;
}

.stylish-btn:active {
    transform: scale(0.95);
}

.whatsapp-btn:hover {
    background-color: #25D366 !important;
}

.chat-btn:hover {
    background-color: #00695C !important;
}

.map-btn:hover {
    background-color: #1565C0 !important;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(0, 137, 123, 0.4);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(0, 137, 123, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(0, 137, 123, 0);
    }
}

.paid-account-card {
    animation: pulse 2.5s infinite;
}

.paid-mobile-card {
    animation: pulse 2.5s infinite;
}

.location-info {
    line-height: 1.6;
}

.delivery-instructions {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    border-left: 4px solid #00897B;
}

.v-chip {
    cursor: default;
}

.caption {
    line-height: 1.5;
}
</style>